// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleFilledSvg from "@ant-design/icons-svg/es/asn/PoundCircleFilled";
import AntdIcon from '../components/AntdIcon';

var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleFilledSvg
  }));
};

PoundCircleFilled.displayName = 'PoundCircleFilled';
export default React.forwardRef(PoundCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PoundCircleFilled.js
// module id = 1603
// module chunks = 0